import { useState } from 'react';
import Card from '@/components/ui/Card';
import Button from '@/components/ui/Button';
import Input from '@/components/ui/Input';
import LoadingSpinner from '@/components/ui/LoadingSpinner';

export default function DocumentsPage() {
  const [documents] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Documents' },
    { id: 'legal', name: 'Legal Documents' },
    { id: 'financial', name: 'Financial Documents' },
    { id: 'compliance', name: 'Compliance Documents' },
    { id: 'operational', name: 'Operational Documents' },
  ];

  const filteredDocuments = documents.filter((doc: any) => {
    const matchesSearch = doc.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         doc.description?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = selectedCategory === 'all' || doc.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Documents</h1>
        <p className="text-gray-600">Manage and organize your business documents</p>
      </div>

      {/* Search and Filters */}
      <Card className="mb-6">
        <Card.Content>
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="flex-1">
              <Input
                placeholder="Search documents..."
                value={searchTerm}
                onChange={(e: any) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="w-full sm:w-48">
              <select
                value={selectedCategory}
                onChange={(e: any) => setSelectedCategory(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
              >
                {categories.map((cat: any) => (
                  <option key={cat.id} value={cat.id}>{cat.name}</option>
                ))}
              </select>
            </div>
            <Button variant="primary">Upload Document</Button>
          </div>
        </Card.Content>
      </Card>

      {/* Documents Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {false ? (
          <div className="col-span-full flex justify-center py-12">
            <LoadingSpinner size="lg" />
          </div>
        ) : filteredDocuments.length === 0 ? (
          <div className="col-span-full text-center py-12">
            <div className="text-gray-500">
              {searchTerm || selectedCategory !== 'all' 
                ? 'No documents found matching your criteria.' 
                : 'No documents uploaded yet.'}
            </div>
            <Button variant="primary" className="mt-4">
              Upload Your First Document
            </Button>
          </div>
        ) : (
          filteredDocuments.map((doc: any) => (
            <Card key={doc.id} className="hover:shadow-md transition-shadow">
              <Card.Content>
                <div className="flex items-start justify-between mb-4">
                  <div className="flex-1">
                    <h3 className="font-medium text-gray-900">{doc.name}</h3>
                    <p className="text-sm text-gray-500 mt-1">{doc.description}</p>
                  </div>
                  <div className="ml-4">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                      {doc.category}
                    </span>
                  </div>
                </div>
                <div className="flex items-center justify-between text-sm text-gray-500">
                  <span>Uploaded {doc.uploadDate}</span>
                  <span>{doc.fileSize}</span>
                </div>
                <div className="mt-4 flex space-x-2">
                  <Button variant="ghost" size="sm">View</Button>
                  <Button variant="ghost" size="sm">Download</Button>
                  <Button variant="ghost" size="sm">Share</Button>
                </div>
              </Card.Content>
            </Card>
          ))
        )}
      </div>
    </div>
  );
}
